import { css } from "@emotion/react"
import { above } from "@mkt/cp/src/styles/Breakpoints"

export const ctas = css`
  margin-bottom: 32px;

  ${above["m"]} {
    display: none;
  }
`
